import { Shadows } from '@mui/material/styles/shadows';

export const shadows: Shadows = [
  'none',
  'rgba(0, 0, 0, 0.25) 1px 1px 2px, rgba(0, 0, 0, 0.08) 0px 1px 3px',
  'rgba(0, 0, 0, 0.04) 0px 0px 6px, rgba(0, 0, 0, 0.04) 0px 4px 6px',
  'rgba(0, 0, 0, 0.2), 0px 4px 10px 4px',
  'rgba(0, 0, 0, 0.08) 0px 6px 24px',
  'rgba(0, 0, 0, 0.08) 0px 8px 36px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px',
  'rgba(0, 0, 0, 0.08) 0px 16px 64px'
];
